/*
 * this method gets payment details based on paymentId. It is distinguished from getting payment info in true modify
 * because true modify gbo session usually comes with a payment object, whereas inflight payment info is saved
 * in the gma reservation object
 */
import { actions, services } from "@ehi/global-marketing-interface";

export const getInflightPaymentDetails = () => (dispatch, getState) => {
    const paymentId = getState().getIn(['gmi', 'ui', 'reservations', 'commit', 'payment_ids', 0]);
    return dispatch(
        actions.request({
            data: { paymentId },
            service: services.gma.reservations.getPaymentDetailsByPaymentId,
        })
    );
};